import { MenuItem } from '@blueprintjs/core';
import { Link, type LinkProps } from 'react-router-dom';

import type { MenuItemProps } from '@blueprintjs/core';
import type { ClassAndStyle } from '@pi/ui';

export interface LinkButtonProps
    extends Omit<MenuItemProps, 'onClick' | 'href' | 'text'>,
        ClassAndStyle {
    to: string;
    text: React.ReactNode;
    linkProps?: Omit<LinkProps, 'to'>;
}

const LinkMenuItem: React.FC<LinkButtonProps> = ({ to, linkProps, ...buttonProps }) => (
    <Link to={to} style={{ color: 'inherit' }}>
        <MenuItem {...buttonProps} />
    </Link>
);

export default LinkMenuItem;
